export default {
  name: 'cPreloader',

  props: {
    color: {
      type: String,
      default: 'black'
    }
  }
}
